import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NotificationService } from '../services/notifications.service';

@Component({
  selector: '',
  template: '',
})
export class PremiumDueHandler extends BaseSearchComponent<NotificationService> implements OnInit {
  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
